// Country dial codes supported dai selettori prefisso (SignaturePad +
// SendProposalModal). Ordine: dal più lungo al più corto per match prefisso
// greedy corretto (es. +358 prima di +35, +351 prima di +35, +420 prima di +42).
export const SUPPORTED_DIAL_CODES = [
  '+420', '+358', '+351',
  '+91', '+86', '+82', '+81', '+64', '+61', '+55', '+54', '+52', '+49', '+48',
  '+47', '+46', '+45', '+44', '+43', '+41', '+39', '+36', '+34', '+33', '+32',
  '+31', '+30', '+27', '+7', '+1',
] as const;

export interface ParsedPhone {
  prefix: string;
  number: string;
}

/**
 * Estrae prefisso + numero da una stringa telefono. Logica:
 *  - Trim e normalizza spazi.
 *  - Se inizia con '+': match contro lista NOTA di prefissi paese (più lungo
 *    prima). Se nessun match nella lista, lascia tutto come number con
 *    fallback prefix='+39' — preferiamo NON tagliare il numero in modo errato.
 *  - Se NON inizia con '+': prefisso=default ('+39'), number=tutto.
 *
 * Bug fix Linda 09-06-2026: il regex precedente `^(\+\d{1,4})` era greedy e
 * mangiava cifre dal numero (es. +39<3>345805178 → prefix +393, number 345...).
 */
export function parsePhoneWithPrefix(
  raw: string | null | undefined,
  defaultPrefix = '+39',
): ParsedPhone {
  const cleaned = (raw ?? '').toString().trim();
  if (!cleaned) {
    return { prefix: defaultPrefix, number: '' };
  }

  if (cleaned.startsWith('+')) {
    // Match contro lista nota — primo che combacia (lista già ordinata desc)
    for (const code of SUPPORTED_DIAL_CODES) {
      if (cleaned.startsWith(code)) {
        const rest = cleaned.slice(code.length).replace(/\s+/g, '');
        return { prefix: code, number: rest };
      }
    }
    // Nessun match noto: NON tagliamo a caso, tutto nel numero col default
    return { prefix: defaultPrefix, number: cleaned.replace(/\s+/g, '') };
  }

  // Senza '+' davanti: lasciamo intatto il numero, prefisso=default
  return { prefix: defaultPrefix, number: cleaned.replace(/\s+/g, '') };
}
